var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from '@/libs/axios';
var EmpresaService = /** @class */ (function () {
    function EmpresaService() {
    }
    EmpresaService.getAll = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.getAll] GET', this.BASE_URL);
                        return [4 /*yield*/, axios.get(this.BASE_URL)];
                    case 1:
                        response = _a.sent();
                        console.debug('[EmpresaService.getAll] status', response.status, 'items', Array.isArray(response.data) ? response.data.length : 'n/a');
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al obtener empresas:', error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.getById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.getById] GET', "".concat(this.BASE_URL, "/").concat(id));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Error al obtener empresa ".concat(id, ":"), error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.create = function (empresa) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.create] POST', this.BASE_URL, empresa);
                        return [4 /*yield*/, axios.post(this.BASE_URL, empresa)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Error al crear empresa:', error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.update = function (id, empresa) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.update] PUT', "".concat(this.BASE_URL, "/").concat(id), empresa);
                        return [4 /*yield*/, axios.put("".concat(this.BASE_URL, "/").concat(id), empresa)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_4 = _a.sent();
                        console.error("Error al actualizar empresa ".concat(id, ":"), error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.delete = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.delete] DELETE', "".concat(this.BASE_URL, "/").concat(id));
                        return [4 /*yield*/, axios.delete("".concat(this.BASE_URL, "/").concat(id))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error("Error al eliminar empresa ".concat(id, ":"), error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.searchByName = function (nombre) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.searchByName] GET', "".concat(this.BASE_URL, "/search/nombre/").concat(encodeURIComponent(nombre)));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/search/nombre/").concat(encodeURIComponent(nombre)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_6 = _a.sent();
                        console.error("Error al buscar empresas por nombre \"".concat(nombre, "\":"), error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.searchByCif = function (cif) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.searchByCif] GET', "".concat(this.BASE_URL, "/search/cif/").concat(encodeURIComponent(cif)));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/search/cif/").concat(encodeURIComponent(cif)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_7 = _a.sent();
                        console.error("Error al buscar empresas por CIF \"".concat(cif, "\":"), error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.searchByEmail = function (email) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.searchByEmail] GET', "".concat(this.BASE_URL, "/search/email/").concat(encodeURIComponent(email)));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/search/email/").concat(encodeURIComponent(email)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_8 = _a.sent();
                        console.error("Error al buscar empresas por email \"".concat(email, "\":"), error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.searchByObservaciones = function (observaciones) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.searchByObservaciones] GET', "".concat(this.BASE_URL, "/search/observaciones?observaciones=").concat(encodeURIComponent(observaciones)));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/search/observaciones?observaciones=").concat(encodeURIComponent(observaciones)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_9 = _a.sent();
                        console.error("Error al buscar empresas por observaciones \"".concat(observaciones, "\":"), error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.getByTipoEmpresa = function (idTipoEmpresa) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.getByTipoEmpresa] GET', "".concat(this.BASE_URL, "/tipo/").concat(idTipoEmpresa));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/tipo/").concat(idTipoEmpresa))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_10 = _a.sent();
                        console.error("Error al obtener empresas por tipo ".concat(idTipoEmpresa, ":"), error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.existsById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.existsById] GET', "".concat(this.BASE_URL, "/exists/").concat(id));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/exists/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_11 = _a.sent();
                        console.error("Error al verificar existencia de la empresa ".concat(id, ":"), error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.existsByCif = function (cif) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.debug('[EmpresaService.existsByCif] GET', "".concat(this.BASE_URL, "/exists/cif/").concat(encodeURIComponent(cif)));
                        return [4 /*yield*/, axios.get("".concat(this.BASE_URL, "/exists/cif/").concat(encodeURIComponent(cif)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_12 = _a.sent();
                        console.error("Error al verificar existencia de la empresa con CIF \"".concat(cif, "\":"), error_12);
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmpresaService.BASE_URL = '/empresas';
    return EmpresaService;
}());
export { EmpresaService };
